<template>
  <div>
    <el-form-item label="推广目的" prop="landing_type">
      <el-radio-group v-model="projectForm.landing_type" @change="onLandingTypeChange">
        <el-radio-button ghost v-if="[PLATFORM.ANDROID, PLATFORM.IOS].includes(projectForm.ch_platform_id)" :label="LANDING_TYPE.APP">
          应用推广
        </el-radio-button>
        <el-radio-button ghost v-if="[PLATFORM.MINI_PROGRAM].includes(projectForm.ch_platform_id)" :label="LANDING_TYPE.MICRO_GAME">
          小程序投放
        </el-radio-button>
      </el-radio-group>

      <p
        v-if="projectForm.ch_platform_id === 3 && projectForm.landing_type === LANDING_TYPE.APP"
        style="color: red; font-size: 12px; margin-top: 6px"
      >
        提示：开启微端推广目的时，回调开关已关闭
      </p>
    </el-form-item>

    <el-form-item label="投放内容" v-if="projectForm.ch_platform_id === PLATFORM.MINI_PROGRAM">
      <el-radio-group v-model="projectForm.micro_promotion_type">
        <el-radio-button ghost label="WECHAT_GAME"> 微信小游戏 </el-radio-button>
        <el-radio-button ghost label="BYTE_GAME"> 字节小游戏 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item v-if="projectForm.ch_platform_id === PLATFORM.MINI_PROGRAM" label="小游戏资产ID" prop="micro_app_instance_id">
      <el-input v-model="projectForm.micro_app_instance_id" style="width: 320px" placeholder="请输入小游戏资产id"></el-input>
    </el-form-item>
    <el-form-item label="子目的" prop="app_promotion_type" v-if="[PLATFORM.ANDROID, PLATFORM.IOS].includes(projectForm.ch_platform_id)">
      <el-radio-group v-model="projectForm.app_promotion_type" :disabled="isDuplicate || isModify" @change="onAppPromotionTypeChange">
        <el-radio-button ghost :label="APP_PROMOTION_TYPE.DOWNLOAD"> 应用下载 </el-radio-button>
        <el-radio-button ghost :label="APP_PROMOTION_TYPE.LAUNCH" disabled> 应用调起 </el-radio-button>
        <el-radio-button ghost :label="APP_PROMOTION_TYPE.RESERVE"> 预约下载 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="计划类型" prop="ad_type">
      <el-radio-group v-model="projectForm.ad_type" @change="onAdTypeChange">
        <el-radio-button ghost :label="AD_TYPE.ALL">通投计划</el-radio-button>
        <el-radio-button ghost :label="AD_TYPE.SEARCH">搜索计划</el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="预约链接" v-show="isReservation" prop="subscribe_url">
      <el-input v-model="projectForm.subscribe_url" placeholder="请输入预约链接"></el-input>
    </el-form-item>

    <!-- ios 应用下载时显示子链接 -->
    <el-form-item
      v-if="[APP_PROMOTION_TYPE.DOWNLOAD].includes(projectForm.app_promotion_type) && projectForm.ch_platform_id === PLATFORM.IOS"
      label="应用链接"
      prop="download_url"
    >
      <el-input v-model="projectForm.download_url" placeholder="请输入应用链接"></el-input>
    </el-form-item>
    <el-form-item v-if="!isV3" label="关联星广联投任务" prop="star_task">
      <el-select
        v-model="projectForm.star_task"
        value-key="star_task_id"
        :disabled="isModify"
        filterable
        clearable
        placeholder="请选择"
        style="width: 320px"
      >
        <el-option v-for="task in starDeliveryTaskList" :key="task.star_task_id" :label="task.star_task_name" :value="task"></el-option>
      </el-select>

      <!-- 关联星广联投任务选择了任意一个才显示自动优选素菜开关 -->
      <div v-if="!!(projectForm.star_task && projectForm.star_task.star_task_id)" class="star-auto-material-switch">
        <el-switch v-model="projectForm.star_auto_material_addition_switch" disabled active-value="ON" inactive-value="OFF"> </el-switch>
        <p>自动优选素材：开启后系统会替换/暂停/删除本项目下计划素材</p>
      </div>
    </el-form-item>

    <el-form-item label="投放模式" prop="delivery_mode">
      <el-radio-group v-if="isV3 || projectForm.ad_type === AD_TYPE.ALL" v-model="projectForm.delivery_mode" @change="onDeliveryModeChange">
        <el-radio-button ghost :label="DELIVERY_MODE.PROCEDURAL" :disabled="isReservation"> 自动投放（UBMax） </el-radio-button>
        <el-radio-button v-if="!isV3" ghost :label="DELIVERY_MODE.MANUAL"> 手动投放 </el-radio-button>
      </el-radio-group>

      <el-radio-group
        v-if="!isV3 && projectForm.ad_type === AD_TYPE.SEARCH"
        v-model="projectForm.delivery_type"
        @change="onDeliveryTypeChange"
      >
        <!-- <el-radio-button ghost :label="DELIVERY_TYPE.NORMAL"> 常规投放 </el-radio-button> -->
        <el-radio-button ghost :label="DELIVERY_TYPE.DURATION"> 极速智投 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item label="营销场景" prop="marketing_goal">
      <el-radio-group v-model="projectForm.marketing_goal">
        <el-radio-button ghost :label="MARKETING_GOAL.VIDEO_AND_IMAGE"> 短视频+图文 </el-radio-button>
        <el-radio-button ghost :label="MARKETING_GOAL.LIVE"> 直播 </el-radio-button>
      </el-radio-group>
    </el-form-item>

    <el-form-item v-if="isV3" label="定向设置" prop="audience_type">
      <el-radio-group v-model="projectForm.audience_type">
        <el-radio-button ghost :label="PROJECT_AUDIENCE_TYPE.UNLIMITED">不限</el-radio-button>
        <el-radio-button ghost :label="PROJECT_AUDIENCE_TYPE.CUSTOM">自定义</el-radio-button>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script setup>
import { computed, inject, ref, watch } from 'vue'
import { getStarDeliveryTaskList } from '@/api/toutiao.local.model.js'

import { PLATFORM } from '@/common/js/constants.js'
import {
  LANDING_TYPE,
  APP_PROMOTION_TYPE,
  DELIVERY_MODE,
  DELIVERY_TYPE,
  MARKETING_GOAL,
  AD_TYPE,
  PROJECT_AUDIENCE_TYPE
} from '../../consts/index.js'
import { useMarketingSceneForm } from './useProject.js'
import { usePageStates } from '../../hooks/useCommonComputeds.js'

// eslint-disable-next-line
const props = defineProps({
  form: Object
})

const { configForm, updateConfigForm } = inject('configForm')
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })

// 星广联投任务列表
const starDeliveryTaskList = ref([])

watch(
  [isV3, () => configForm.value.accounts?.[0]],
  ([v3, account]) => {
    if (v3 || !account) return
    getTaskList(account)
  },
  { immediate: true }
)
const { isDuplicate, isModify } = usePageStates()
const projectForm = computed(() => props.form)

watch(
  [isV3, () => projectForm.value.delivery_type],
  ([v3, deliveryType]) => {
    if (v3 && deliveryType !== DELIVERY_TYPE.NORMAL) {
      projectForm.value.delivery_type = DELIVERY_TYPE.NORMAL
    }
  },
  { immediate: true }
)

const {
  isReservation,
  gameListFilterdByPlatform,
  onAdTypeChange,
  onLandingTypeChange,
  onAppPromotionTypeChange,
  onDeliveryModeChange,
  onDeliveryTypeChange
} = useMarketingSceneForm(projectForm, null, { isV3 })

function getTaskList(account) {
  getStarDeliveryTaskList({ advertiserId: account.advertiserId, adAccount: account.adAccount }).then((data) => {
    if (data?.length) {
      starDeliveryTaskList.value = data
    } else {
      starDeliveryTaskList.value = []
      const newForm = {
        ...configForm.value
      }
      // 清空创意素材
      if (configForm.value.project?.star_task.star_task_id) {
        newForm.creatives = []
      }
      newForm.project.star_task = {}
      newForm.project.star_task_list = []

      // 如果没有星广联投任务列表，清空
      updateConfigForm(newForm)
    }
  })
}
</script>

<style lang="scss" scoped>
.star-auto-material-switch {
  display: flex;
  align-items: center;
  margin-top: 6px;
  p {
    font-size: 12px;
    margin-left: 10px;
  }
}
</style>
